import React, { useContext } from 'react';
import { Route, Routes } from 'react-router';
import { authRoutes, publicRoutes } from '../router/routes';
import { MainContext } from '..';
import { observer } from 'mobx-react-lite';

const AppRouter = observer(() => {
    const { user } = useContext(MainContext);

    return (
        <Routes>
            {user.isAuth &&
                authRoutes.map((route) => (
                    <Route
                        key={route.path}
                        exact={route.exact}
                        path={route.path}
                        element={route.element}
                    />
                ))}
            {publicRoutes.map((route) => (
                <Route
                    key={route.path}
                    exact={route.exact}
                    path={route.path}
                    element={route.element}
                />
            ))}
        </Routes>
    );
});

export default AppRouter;

